import { ActionResponse } from '../models/actionResponse/types';
import { SustainabilityDocument } from '../redux/actions/productActions/types';
import { getSustainabilityDocumentTypesAction } from '../redux/actions/transparencyCatalogActions';

export const getAllSustainabilityDocuments = async (dispatch: any): Promise<SustainabilityDocument[] | undefined> => {
    const { payload } = (await dispatch(
        getSustainabilityDocumentTypesAction(),
    )) as ActionResponse<SustainabilityDocument[]>;

    return payload?.data;
};